export class AuthorizationEmailOption {
    id: string = "";
    value: string = "";
}
